import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// nm2024 themed components
import { CredentialCardSetNm2024  } from '../../../../nm2024Theme/components/credentialCardSet/styles';
// styles
import {
  SectionContainerNm2024Styled,
  TypographyNm2024Styled,
} from './styles';

export default () => (
  <SectionContainerNm2024Styled
    id='home-credential-callout'
    moduleName='credentials-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col>
        <TypographyNm2024Styled
          component='h2'
          align='center'
          typeface='serif'
          disableBottomPadding>
          Your financial strength, powered <WidowBlock>by ours.</WidowBlock>
        </TypographyNm2024Styled>
      </Col>
    </Row>
    <CredentialCardSetNm2024
      credentials={[
        {
          credential: 'financialStrengthRating',
          sup1: 2,
        },
        {
          credential: 'rankedInvestmentService',
          sup1: 3,
        },
        {
          credential: 'totalDividendPayout',
          sup1: 4,
        },
        {
          credential: 'rankedInsuranceCompany',
          sup1: 5,
        },
      ]}
    />
  </SectionContainerNm2024Styled>
);
